'use strict';

var React = require('react');

const useIsTruncated = (element) => {
    const [isTruncated, setIsTruncated] = React.useState(false);
    const measure = React.useCallback(() => {
        if (!element)
            return;
        const { scrollWidth, clientWidth, scrollHeight, clientHeight } = element;
        const isSingleLine = scrollWidth > clientWidth;
        const isMultiLine = scrollHeight > clientHeight;
        setIsTruncated(isSingleLine || isMultiLine);
    }, [element]);
    React.useLayoutEffect(() => {
        if (!element)
            return;
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(element);
        document.fonts?.ready.then(measure);
        return () => ro.disconnect();
    }, [element, measure]);
    return isTruncated;
};

exports.useIsTruncated = useIsTruncated;
//# sourceMappingURL=useIsTruncated.js.map
